import { Box, Drawer } from "@mui/material";
import React, { useState } from "react";
import { useAppSelector } from "../../../hooks/useRedux";

interface Props {
  height?: string;
  open: boolean;
  onDismiss: React.Dispatch<React.SetStateAction<boolean>>;
  children?: JSX.Element[] | JSX.Element;
}

export default function BottomSheetLayout(props: Props) {
  const { onDismiss, open, children, height } = props;
  const { isOpenKeyboard } = useAppSelector((state) => state.settings);

  return (
    <Drawer
      transitionDuration={200}
      anchor={"bottom"}
      open={open}
      onClose={() => onDismiss(false)}
    >
      <style>
        {`
                .MuiPaper-root {
                max-width:450px;
                z-index:500;
                
                height:${isOpenKeyboard ? height : `calc( ${height} - 58px)`};
                margin:auto;
                bottom:${isOpenKeyboard ? "0px" : "58px"};
                direction:rtl;


                }
                `}
      </style>
      {children}
    </Drawer>
  );
}
